export const colorPalettes = {
  normal: {
    single: { all: { color: '#00B1B2' } },
    scale: { start: '#f0f0f0', end: '#00B1B2' },
    categorical: [
      '#142F4E',
      '#09A6A7',
      '#2A62A2',
      '#03D7D7',
      '#158AAA',
      '#87FFFF',
      '#1F4978',
      '#03BEBE',
      '#256CA4',
      '#33F6F6',
      '#0B9EAE',
      '#B7FFFF',
    ],
  },
  deuteranopia: {
    single: { all: { color: '#454545' } },
    scale: { start: '#f0f0f0', end: '#454545' },
    categorical: ['#454545'],
  },
  tritanopia: {
    single: { all: { color: '#454545' } },
    scale: { start: '#f0f0f0', end: '#454545' },
    categorical: ['#454545'],
  },
}

export function buildColorDict(colors, selection, current) {
  current = current || {}
  current = JSON.parse(JSON.stringify(current))
  for (let key in current) {
    if (selection.find(d => d.id === key) === void 0) delete current[key]
  }
  const assigneds = Object.fromEntries(Object.values(current).map(d => [colors.indexOf(d), true]))
  const colorDict = selection.reduce((acum, d, i) => {
    const availableColors = colors.filter((d, i) => assigneds[i] !== true)
    acum[d.id] = acum[d.id] || availableColors[i % availableColors.length]
    delete assigneds[i]
    return acum
  }, current)
  // colorDict.others = '#00B1B2'
  colorDict.others = '#ccc'
  return colorDict
}

export function lightColor(color, percent) {
  var bands,
    opacity = 1
  if (color.slice(0, 4) === 'rgba') {
    bands = color
      .slice(5)
      .replace(/\)/, '')
      .split(',')
    opacity = bands.pop()
  } else if (color.slice(0, 3) === 'rgb') {
    bands = color
      .slice(4)
      .replace(/\)/, '')
      .split(',')
  } else if (color[0] === '#') {
    bands = color
      .slice(1)
      .split('')
      .reduce(
        (acum, d, i) => {
          acum[Math.floor(i / 2)] += d
          return acum
        },
        ['', '', '']
      )
      .map(d => parseInt(d, 16))
  }

  const lighter =
    'rgba(' +
    bands.map(d => Math.floor(Math.min(255, d + 255 * (percent / 100)))).join(',') +
    ',' +
    opacity +
    ')'
  return lighter
}
